"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getBaseReducers2 = _interopRequireDefault(require("../../utils/get-base-reducers"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @param {object} state - Redux state slice.
 * @param {object} action - Redux Action.
 * @param {object=} action.data - Data from a fetch call.
 * @param {string=} action.type - Action type called from the action creator.
 *
 * @returns {object} New redux state after action is applied.
 */
var maintenanceReducer = function maintenanceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _getBaseReducers = (0, _getBaseReducers2["default"])({
      action: action,
      state: state
    }),
    error = _getBaseReducers.error,
    progress = _getBaseReducers.progress,
    success = _getBaseReducers.success;
  var reducers = {
    MAINTENANCE_CHECK_STATUS_ERROR: error,
    MAINTENANCE_CHECK_STATUS_PROGRESS: progress,
    MAINTENANCE_CHECK_STATUS_SUCCESS: function MAINTENANCE_CHECK_STATUS_SUCCESS() {
      return (0, _fp.merge)(success(), {
        data: action.data
      });
    }
  };
  return reducers[action.type] ? reducers[action.type]() : state;
};
var _default = exports["default"] = maintenanceReducer;
module.exports = exports.default;